export default function isJsonString(str) {
            try {
                JSON.parse(str);
                return true;
            } catch {
                return false;
            }
        }


// WEBPACK FOOTER //
// ./src/common/fragments/CheckJson.tsx